module.exports = __webpack_public_path__ + "media/images/share-f9f5b640a2fe9d5975ffec377b6ac062.png";